import { Icon } from '@material-ui/core';
import { motion } from 'framer-motion';
import React from 'react';
import { useBasicDetails } from '../../store';
import { verticalTimeline } from '../styles/verticalTimeline';
import { ReactComponent as Spinner } from '../Images/spinner.svg';
import DownArrow from './downArrow';

const Transition = ({ children, isTrans = false, isNextItemAssessment = true }: any): JSX.Element => {
  const {
    template: {
      settings: {
        page: { timeline },
      },
    },
    timeLineSpinner,
  } = useBasicDetails();
  const classes = verticalTimeline(timeline);
  return (
    <>
      {
        <motion.div
          animate={{ opacity: 1, y: 0 }}
          initial={{ opacity: 1, y: 410 }}
          exit={{ opacity: 0.2, y: -650 }}
          transition={{ duration: 1.0 }}>
          {children}
        </motion.div>
      }
      <>
        {isTrans && (
          <motion.div
            animate={{ opacity: 1, y: 0 }}
            initial={{ opacity: 1, y: 410 }}
            exit={{ opacity: 0.2, y: -650 }}
            transition={{ duration: 1.0 }}>
            {!isNextItemAssessment && !timeLineSpinner && (
              <Icon className={classes.spinner}>
                <DownArrow />
              </Icon>
            )}
            {timeLineSpinner ? (
              <Icon data-testid="loaderIcon" className={classes.spinner}>
                <Spinner className={classes.circle} />
              </Icon>
            ) : (
              <></>
            )}
          </motion.div>
        )}
      </>
    </>
  );
};
export default Transition;
